import { useState } from "react";
import { SendHorizontal } from "lucide-react";
import { NavLink } from "react-router-dom";

export default function ContactForm({ t, lang }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {


    const res = await fetch("/api/send_mail.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...formData,
      })
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Erreur");

    setStatus("Message envoyé avec succès ✨");
    setFormData({ name: "", email: "", message: "" });

  } catch (err) {
    setStatus("Erreur lors de l'envoi du message ❌");
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  return (
    <section id="contact" className="py-5">
      <div className="container" style={{maxWidth:"800px"}}>
        <a className="mail-text" href="mailto:juliehuguet.contact@gmail.com" style={{fontFamily:'pangram-sans-medium'}}>juliehuguet.contact@gmail.com</a>
      </div>
        <div className="d-flex justify-content-center mt-4">
          <NavLink
            to="https://www.instagram.com/flutejuliehuguet"
            target="_blank"
            className="text-black text-decoration-none me-2"
          >
          <img style={{height:'45px'}} src="../images/instagram.png"></img>
          </NavLink>

          <NavLink
            to="https://www.youtube.com/@huguetjulie610"
            target="_blank"
            className="text-black text-decoration-none me-2"
          >
          <img style={{height:'45px'}} src="../images/youtube.png"></img>
          </NavLink>

          <NavLink
            to="https://www.facebook.com/juliehuguet.13"
            target="_blank"
            className="text-black text-decoration-none"
          >
          <img style={{height:'45px'}} src="../images/facebook.png"></img>
          </NavLink>
        </div>
    </section>
  );
}